export default __webpack_public_path__ + "static/media/dashboard_flux_de_travail.1a173e86.png";